module.exports = __webpack_public_path__ + "static/img/social_widget_2.10a7d01.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/social_widget_2.png
// module id = GPBY
// module chunks = 11